export default __webpack_public_path__ + "static/media/walmart.bfadc730.svg";